module.exports = __webpack_public_path__ + "img/报表.png";